type Context = 'integration';

type IntegrationType = 'salesforce';

type Section =
  | 'company-mappings'
  | 'contact-mappings'
  | 'owner-mappings'
  | 'owners'
  | 'fbl-fields'
  | 'fields'
  | 'field-mappings'
  | 'record-types-list'
  | 'record-type-selected'
  | 'settings';

type Value = `${Context}-${IntegrationType}-${Section}`;

export const Keys: Record<Section, Value> = {
  'company-mappings': 'integration-salesforce-company-mappings',
  'contact-mappings': 'integration-salesforce-contact-mappings',
  'owner-mappings': 'integration-salesforce-owner-mappings',
  owners: 'integration-salesforce-owners',
  'fbl-fields': 'integration-salesforce-fbl-fields',
  fields: 'integration-salesforce-fields',
  'field-mappings': 'integration-salesforce-field-mappings',
  'record-types-list': 'integration-salesforce-record-types-list', // to list all available record types for a given object type
  'record-type-selected': 'integration-salesforce-record-type-selected', // to show the selected record type for diff object types
  settings: 'integration-salesforce-settings',
};
